module.exports = __webpack_public_path__ + "img/landing_page_header.be62c894.webp";